var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"guide",staticClass:"guide"},[_c('div',{staticClass:"guide-container"},[_c('img',{staticClass:"image",attrs:{"src":"https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f7f8c73ffc6ee077e618440b44e8e0ec.png","alt":""}}),_c('div',{staticClass:"point-list"},_vm._l((_vm.pointList),function(item,index){return _c('div',{key:index,staticClass:"point-item",style:({
          left: _vm.getPosition(item.left),
          top: _vm.getPosition(item.top),
          width: _vm.getPosition(item.width),
          height: _vm.getPosition(item.height)
        }),on:{"click":function($event){return _vm.bindClick(item)}}})}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }